import { DatePipe } from '@angular/common';
import { CommonService } from './../../../services/common.service';
import { UserService } from './../../../services/user.service';
import { StoreService } from './../../../services/store.service';
import { CommonMessageService } from './../../../services/common-message.service';
import { PickCountryComponent } from './../pick-country/pick-country.component';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-user-infos',
  templateUrl: './user-infos.component.html',
  styleUrls: ['./user-infos.component.scss'],
})
export class UserInfosComponent implements OnInit {
  userForm: FormGroup;
  imageForm: FormGroup;
  @Input() user;
  sizeSup: Boolean;
  fileName: String;
  fileOk: Boolean;
  msg;
  image: any;
  uploadedFiles: any[] = [];
  changeInfo: boolean;
  changeImage: boolean;
  fileFromOk: boolean;
  constructor(private modalController: ModalController, private formBuilder: FormBuilder,
    private commonMessager: CommonMessageService,
    private store: StoreService,
    public userService: UserService,
    private common: CommonService,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.changeInfo = true;
    this.fileFromOk = true;
    this.buildRegisterForm();
    this.buildImageForm();
    console.log('user: ', this.user);
  }
  close(data?) {
    this.modalController.dismiss(data);
  }

  private buildRegisterForm() {
    this.userForm = this.formBuilder.group({
      nom: [this.user && this.user.nom, [Validators.required]],
      prenom: [this.user && this.user.prenom, [Validators.required]],
      loginEmail: [this.user && this.user.loginEmail, [Validators.required]],
      telephones: [this.user && this.user.telephones, [Validators.required, Validators.minLength(8)]],
      sexe: [this.user && this.user.sexe, [Validators.required]],
      dateNaissance: [this.user && this.datePipe.transform(new Date(this.user.dateNaissance), 'yyyy-MM-dd'), [Validators.required]],
      adresse: [this.user && this.user.adresse, [Validators.required]],
      pays: [this.user && this.user.pays, [Validators.required]],
      image: [this.user && this.user.lienPhotoProfil],
    });
  }
  closeChangeImage() {
    this.fileFromOk = true;
    this.fileOk = false;
  }
  private buildImageForm() {
    this.imageForm = this.formBuilder.group({
      imageName: [''],
    });
  }

  async pickCountry(ev) {
    ev.stopPropagation();
    const modal = await this.modalController.create({
      component: PickCountryComponent,
      mode: 'ios',
      cssClass: 'transparent-modal',
      backdropDismiss: true,
      showBackdrop: true,
      animated: true,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    console.log('data: ', data);
    if (!data) {
      return;
    }
    this.userForm.get('pays').setValue(data.paysFr);
  }

  async doChangeImage() {
    const loading = await this.commonMessager.loading('Patientez un instant');
    try {
      const formData = new FormData();
      formData.append('files', this.uploadedFiles[0]);
      formData.append('idPostulant', this.user.idPostulant);
      const data = (await this.userService.modifyImage(formData).toPromise()) as any;
      console.log('data: ', data);
      this.commonMessager.successToast('Modification effectuée avec succès ...');
    } catch (error) {
      // this.commonMessager.errorToast('Erreur:  ' + error, 10000);
      this.commonMessager.alert(error, 'Erreur', '');
    } finally {
      loading.dismiss();
    }
  }

  async register() {
    const loading = await this.commonMessager.loading('Patientez un instant');
    try {
      const dataToSend = { idPostulant: this.user.idPostulant + '', ...this.userForm.value };
      console.log('dataToSend: ', dataToSend);
      const data = (await this.userService.mofidyPostulant(dataToSend).toPromise()) as any;
      this.userService.currentUser = data;
      await this.store.setValue('email', data.email);
      await this.store.setValue('postulant', data);
      this.commonMessager.successToast('Modification effectuée avec succès ...');
    } catch (error) {
      // this.commonMessager.errorToast('Erreur:  ' + error, 10000);
      this.commonMessager.alert(error, 'Erreur', '');
    } finally {
      loading.dismiss();
    }
  }
  detectFiles0(event) {
    this.uploadedFiles[0] = event.target.files[0];
    console.log('file: ', this.uploadedFiles[0]);
    this.fileName = this.uploadedFiles[0].name;
    const reader = new FileReader();
    reader.readAsDataURL(this.uploadedFiles[0]);
    reader.onload = () => {
      this.image = reader.result;
    };
    this.fileOk = true;
    this.fileFromOk = false;
    this.sizeSup = false;
    if (this.uploadedFiles[0].size > 10000000) {
      this.msg = this.uploadedFiles[0].size > 10000000 ? 'La taille du fichier est depassée' : 'Merci de mettre votre CV en PDF';
      this.sizeSup = true;
      this.uploadedFiles = [];
      event.target.files = null;
      this.fileOk = false;
    }
  }

  showUserForm() {
    this.changeInfo = true;
    this.changeImage = false;
  }

  showImageForm() {
    this.changeInfo = false;
    this.changeImage = true;
  }
}
